import { createReducer, on } from "@ngrx/store";
import { clearCurrentCustomer } from './customer.actions';
import { Customer } from "../../models/Customer";
import * as CustomerActions from './customer.actions'
import { GatewayCustomer } from "../../models/GatewayCustomer";
import { GatewayContact } from "../../models/GatewayContact";

export interface CustomerState {
  customer: Customer | null;
  allCustomers: GatewayCustomer[] | null;
  registeredCustomers: Customer[] | null;
  employeesOfCustomer: Customer[] | null;

  selectedGatewayCustomer: GatewayCustomer | null;
  selectedCustomer: Customer | null;
  selectedContact: GatewayContact | null;
}

export const initialState: CustomerState = {
  customer: null,
  allCustomers: null,
  registeredCustomers: null,
  employeesOfCustomer: null,

  selectedGatewayCustomer: null,
  selectedCustomer: null,
  selectedContact: null,
}

export const customerReducer = createReducer(
  initialState,
  on(CustomerActions.getAllCustomersSuccess, (state, {customers}) => ({
    ...state,
    allCustomers: customers
  })),
  on(CustomerActions.getRegisteredCustomersSuccess, (state, {customers}) => ({
    ...state,
    registeredCustomers: customers
  })),
  on(CustomerActions.getCustomerByIdSuccess, (state, {customer}) => ({
    ...state,
    customer: customer,
  })),
  on(CustomerActions.getCustomerByUserNameSuccess, (state, {customer}) => ({
    ...state,
    customer: customer
  })),
  on(CustomerActions.getCurrentCustomerSuccess, (state, {customer}) => ({
    ...state,
    customer: customer
  })),
  on(CustomerActions.updateCoinsSuccess, (state, {customer}) => ({
    ...state,
    customer: customer,
    selectedCustomer: customer
  })),
  on(CustomerActions.getContactDataByNameShorthandSuccess, (state, {contact}) => ({
    ...state,
    selectedContact: contact
  })),
  on(CustomerActions.getCustomerByReflexIdSuccess, (state, {customer}) => ({
    ...state,
    selectedCustomer: customer,
  })),
  on(CustomerActions.getGatewayCustomerByReflexIdSuccess, (state, {customer}) => ({
    ...state,
    selectedGatewayCustomer: customer
  })),
  on(CustomerActions.setEntraUserEnabledStateSuccess, (state, { customers }) => ({
    ...state,
    registeredCustomers: state.registeredCustomers
      ? state.registeredCustomers.map(rc => {
          const updated = customers.find(c => c.id === rc.id);
          return updated ? updated : rc;
        })
      : null
  })),

  on(clearCurrentCustomer, (state) => ({
    ...state,
    customer: null
  })),
  on(CustomerActions.clearRegisteredCustomers, (state) => ({
    ...state,
    registeredCustomers: null
  })),
  on(CustomerActions.clearAllCustomers, (state) => ({
    ...state,
    allCustomers: null,
  })),
  on(CustomerActions.clearSelectedCustomer, (state) => ({
    ...state,
    selectedCustomer: null
  })),
  on(CustomerActions.clearSelectedGatewayCustomer, (state) => ({
    ...state,
    selectedGatewayCustomer: null
  })),
  on(CustomerActions.getCustomerEmployeesSuccess, (state, { employees }) => ({
    ...state,
    employeesOfCustomer: employees
  })),
  on(CustomerActions.getCompanyNameByCustomerNosSuccess, (state, { companyNames }) => ({
    ...state,
    registeredCustomers: state.registeredCustomers
      ? state.registeredCustomers.map(customer => {
          const companyInfo = companyNames.find(cn => 
            cn.customerNo === customer.reflexCustomerNo || cn.customerNo === customer.customerReflexId
          );
          if (companyInfo) {
            return new Customer({
              ...customer,
              companyShortName: companyInfo.companyShortName
            });
          }
          return customer;
        })
      : null
  }))
);
